<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <div class="dish-config-container">
        <!-- 添加页面标题 -->
        <div class="page-title">
          <div class="page-title-main">
            <div class="page-icon"><i class="el-icon-food"></i></div>
            <div>
              <div class="page-eyebrow">订餐管理 / 学校级配置</div>
              <h2>{{ departmentName ? (departmentName + ' · 订餐配置') : '订餐配置' }}</h2>
            </div>
          </div>
          <div v-if="DepartmentId > 0" class="school-badge">
            <i class="el-icon-location-outline"></i>{{ departmentName }}
          </div>
        </div>

        <!-- 数据加载状态 - 显示在卡片位置 -->
        <div v-if="loading" class="loading-container" style="min-height: 300px;">
          <div class="loading-content">
            <div class="loading-text">正在加载数据...</div>
          </div>
        </div>

        <!-- 只有当数据加载完成后才渲染表单 -->
        <el-card class="config-card payment-card" v-else-if="DepartmentId > 0">
          <div class="card-heading">
            <div>
              <span class="card-title">基础设置</span>
              <span class="card-caption">控制学校订餐的支付流程</span>
            </div>
            <i class="el-icon-setting card-heading-icon"></i>
          </div>
          <div class="config-form">
            <el-form ref="configForm" :model="configForm" label-width="200px">
              <!-- 订餐支付模式 -->
              <el-form-item label="订餐支付模式" prop="OrderFoodPayMode" class="payment-mode-item">
                <el-radio-group v-model="configForm.OrderFoodPayMode">
                  <el-radio :label="1">先支付</el-radio>
                  <el-radio :label="2">后支付</el-radio>
                </el-radio-group>
              </el-form-item>


            </el-form>
          </div>

          <div class="button-group">
            <el-button type="primary" icon="el-icon-check" @click="handleSave" :loading="loading">保存基础配置</el-button>
          </div>
        </el-card>

        <el-card class="config-card refund-rule-card" v-if="DepartmentId > 0" v-loading="refundRuleLoading">
          <div slot="header" class="refund-rule-header">
            <div>
              <div class="rule-title-line">
                <span class="rule-icon"><i class="el-icon-time"></i></span>
                <span class="card-title">请假退餐时段规则</span>
              </div>
              <p>下方规则用于配置当前时间可以退今天或明天的哪些餐次，未覆盖的时间默认不可退。</p>
              <p class="rule-help-text">具体可退日期和餐次以当前时间命中的时段规则为准；请假期内若当前无可退餐次，手机端不展示勾选项。</p>
            </div>
            <div class="refund-rule-actions">
              <el-button size="small" @click="addRefundRule">新增时段</el-button>
              <el-button size="small" type="primary" :loading="refundRuleSaving" @click="saveRefundRules">
                保存规则
              </el-button>
            </div>
          </div>
          <div v-for="(rule, ruleIndex) in refundRules" :key="ruleIndex" class="refund-rule-row">
            <div class="rule-index">{{ ('0' + (ruleIndex + 1)).slice(-2) }}</div>
            <div class="rule-time-group">
              <span class="rule-field-label">生效时间</span>
              <el-time-picker v-model="rule.StartTime" value-format="HH:mm:ss" placeholder="开始时间"
              size="small"></el-time-picker>
              <span class="refund-rule-separator">至</span>
              <el-time-picker v-model="rule.EndTime" value-format="HH:mm:ss" placeholder="结束时间"
              size="small"></el-time-picker>
            </div>
            <div class="refund-rule-meals">
              <span class="rule-field-label">允许退餐</span>
              <div class="meal-day-group">
                <span class="meal-day-label">今天</span>
                <el-checkbox-group v-model="rule._selections" class="meal-checkboxes">
                  <el-checkbox v-for="meal in refundDinnerTimes" :key="`${ruleIndex}-today-${meal.Id}`"
                    :label="`${ruleIndex}:0:${meal.Id}`">
                    {{ meal.DinnerName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="meal-day-group">
                <span class="meal-day-label">明天</span>
                <el-checkbox-group v-model="rule._selections" class="meal-checkboxes">
                  <el-checkbox v-for="meal in refundDinnerTimes" :key="`${ruleIndex}-tomorrow-${meal.Id}`"
                    :label="`${ruleIndex}:1:${meal.Id}`">
                    {{ meal.DinnerName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <el-button type="text" class="danger-text" @click="removeRefundRule(ruleIndex)">删除</el-button>
          </div>
          <div v-if="!refundRules.length" class="empty-inline">暂无时段规则，请先新增。</div>
        </el-card>

        <!-- 未选择部门时的提示 -->
        <div v-else class="no-department-tip">
          <p>请选择一个部门查看和配置订餐信息</p>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane'
import {
  getOrderFoodConfig,
  saveOrderFoodConfig,
  getLeaveMealRefundWindowRules,
  saveLeaveMealRefundWindowRules,
  getLeaveMealRefundDinnerTimes
} from '../../api/modules/catering';
export default {
  components: { DepartmentPane },
  name: 'DishConfig',
  data() {
    return {
      configForm: {
        OrderFoodPayMode: 1
      },
      loading: false,
      DepartmentId: 0,
      departmentName: '',
      refundRules: [],
      refundDinnerTimes: [],
      refundRuleLoading: false,
      refundRuleSaving: false,
    };
  },
  computed: {
  },
  mounted() {
    // 确保DOM渲染完成后再初始化数据
    this.$nextTick(() => {
      // 初始时不自动加载数据，等待用户选择部门
    });
  },
  methods: {
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.departmentName = data.label || '';
      this.getConfigData();
      this.loadRefundRules();
    },

    // 加载当前学校的请假退餐时段规则
    loadRefundRules() {
      if (!this.DepartmentId) return;
      this.refundRuleLoading = true;
      Promise.all([
        getLeaveMealRefundWindowRules({ schoolId: this.DepartmentId }),
        getLeaveMealRefundDinnerTimes({ departmentId: this.DepartmentId })
      ]).then(([ruleRes, mealRes]) => {
        const dinnerTimes = (mealRes.data && mealRes.data.success && mealRes.data.response) || [];
        const enabledDinnerTimes = dinnerTimes.filter(meal => {
          const enabled = meal.AllowLeaveMealRefund !== undefined
            ? meal.AllowLeaveMealRefund : meal.allowLeaveMealRefund;
          return enabled === true || enabled === 'true' || enabled === 1 || enabled === '1';
        });
        const dinnerTimeMap = {};
        enabledDinnerTimes.forEach(meal => {
          const dinnerTimeId = meal.Id !== undefined ? meal.Id : meal.id;
          if (dinnerTimeId !== undefined && dinnerTimeMap[dinnerTimeId] === undefined) {
            dinnerTimeMap[dinnerTimeId] = meal;
          }
        });
        this.refundDinnerTimes = Object.keys(dinnerTimeMap).map(id => dinnerTimeMap[id]);
        const rules = (ruleRes.data && ruleRes.data.success && ruleRes.data.response) || [];
        this.refundRules = rules.map((rule, index) => {
          const selections = [];
          (rule.Items || []).forEach(item => selections.push(`${index}:${item.DayOffset}:${item.DinnerTimeId}`));
          return Object.assign({}, rule, { _selections: selections });
        });
      }).finally(() => {
        this.refundRuleLoading = false;
      });
    },

    // 新增一个退餐时间段
    addRefundRule() {
      this.refundRules.push({
        StartTime: '00:00:00',
        EndTime: '08:00:00',
        Sort: this.refundRules.length,
        IsEnabled: true,
        _selections: []
      });
    },

    // 删除退餐时间段
    removeRefundRule(index) {
      this.refundRules.splice(index, 1);
    },

    // 保存当前学校的退餐时间段规则
    saveRefundRules() {
      const payload = this.refundRules.map((rule, index) => ({
        Id: rule.Id || 0,
        StartTime: rule.StartTime,
        EndTime: rule.EndTime,
        Sort: index,
        IsEnabled: rule.IsEnabled !== false,
        Items: (rule._selections || []).map(value => {
          const parts = value.split(':');
          return { DayOffset: Number(parts[1]), DinnerTimeId: Number(parts[2]) };
        })
      }));
      this.refundRuleSaving = true;
      saveLeaveMealRefundWindowRules(this.DepartmentId, payload).then(res => {
        if (res.data && res.data.success) this.$message.success('退餐时段规则保存成功');
        else this.$message.error((res.data && res.data.msg) || '保存失败');
      }).finally(() => {
        this.refundRuleSaving = false;
      });
    },

    // 获取配置数据
    getConfigData() {
      this.loading = true;
      getOrderFoodConfig({ DepartmentId: this.DepartmentId }).then(res => {
        this.loading = false;
        if (res && res.data.response) {
          this.configForm = res.data.response;
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('获取配置失败，请稍后重试');
      });
    },

    // 保存配置
    handleSave() {
      this.loading = true;
      const saveData = {
        ...this.configForm,
        DepartmentId: this.DepartmentId
      };
      saveOrderFoodConfig(saveData).then(res => {
        this.loading = false;
        if (res && res.data.success) {
          this.$message.success('配置保存成功');
          this.getConfigData();
        } else {
          this.$message.error(res && res.message || '保存失败，请稍后重试');
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('保存配置失败，请稍后重试');
      });
    },
  }
};
</script>

<style scoped>
.dish-config-container {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 22px 26px 32px;
  box-sizing: border-box;
}

.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.page-title-main {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  color: #2563eb;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  font-size: 20px;
}

.page-eyebrow {
  margin-bottom: 3px;
  color: #94a3b8;
  font-size: 12px;
  letter-spacing: .04em;
}

.page-title h2 {
  font-size: 20px;
  margin: 0;
  color: #172033;
  font-weight: 650;
}

.school-badge {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 11px;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  font-size: 12px;
}

.config-card {
  margin-bottom: 16px;
  border: 1px solid #e5eaf2;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(30, 64, 175, .04);
}

.config-card ::v-deep .el-card__body {
  padding: 20px 22px;
}

.config-card ::v-deep .el-card__header {
  padding: 16px 22px;
  border-bottom: 1px solid #eef2f7;
}

.payment-mode-item ::v-deep .el-form-item__label {
  width: 130px !important;
}

.payment-mode-item ::v-deep .el-form-item__content {
  margin-left: 130px !important;
}

.payment-card {
  min-height: 150px;
}

.card-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.card-caption {
  margin-left: 10px;
  color: #94a3b8;
  font-size: 12px;
}

.card-heading-icon {
  color: #94a3b8;
  font-size: 18px;
}

.refund-rule-card {
  max-width: none;
}

.refund-rule-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.refund-rule-actions {
  display: flex;
  flex-basis: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #eef2f7;
}

.refund-rule-header p {
  margin: 6px 0 0 30px;
  color: #64748b;
  font-size: 12px;
}

.refund-rule-header .rule-help-text {
  margin-top: 3px;
  color: #94a3b8;
}

.rule-title-line {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rule-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  color: #2563eb;
  background: #eff6ff;
  border-radius: 6px;
}

.card-title {
  color: #1e293b;
  font-size: 15px;
  font-weight: 600;
}

.refund-rule-row {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) 42px;
  grid-template-rows: auto auto;
  align-items: center;
  gap: 16px;
  min-height: 58px;
  padding: 10px 12px;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
  background: #fbfcfe;
  border: 1px solid #edf1f6;
  border-radius: 9px;
  margin-bottom: 10px;
}

.rule-index {
  width: 28px;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
}

.refund-rule-separator {
  margin: 0 2px;
  color: #94a3b8;
}

.rule-time-group {
  display: flex;
  align-items: center;
  gap: 6px;
  grid-column: 2;
  grid-row: 1;
  min-width: 0;
}

.rule-field-label {
  flex: 0 0 auto;
  margin-right: 4px;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.refund-rule-meals > .rule-field-label {
  grid-row: 1 / span 2;
  align-self: start;
  padding: 7px 0;
  color: #475569;
  font-weight: 600;
}

.refund-rule-meals {
  display: grid;
  grid-template-columns: 60px minmax(0, 1fr);
  grid-template-rows: repeat(2, auto);
  align-items: center;
  grid-column: 2;
  grid-row: 2;
  gap: 6px 10px;
  min-width: 0;
  padding-left: 16px;
  border-left: 1px solid #e5eaf2;
}

.meal-day-group {
  display: flex;
  align-items: center;
  grid-column: 2;
  gap: 10px;
  min-height: 30px;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 3px 9px 3px 7px;
  background: #fff;
  border: 1px solid #e7edf5;
  border-radius: 6px;
}

.meal-day-label {
  flex: 0 0 32px;
  padding: 4px 7px;
  color: #64748b;
  background: #f1f5f9;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
}

.meal-checkboxes {
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;
  flex-wrap: wrap;
  gap: 10px;
}

.meal-checkboxes ::v-deep .el-checkbox {
  overflow: hidden;
  max-width: none;
  margin: 0;
  padding: 4px 9px;
  color: #475569;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all .18s ease;
}

.meal-checkboxes ::v-deep .el-checkbox:hover {
  border-color: #93c5fd;
  background: #f8fbff;
}

.meal-checkboxes ::v-deep .el-checkbox.is-checked {
  color: #2563eb;
  background: #eff6ff;
  border-color: #93c5fd;
}

.meal-checkboxes ::v-deep .el-checkbox__input {
  display: none;
}

.meal-checkboxes ::v-deep .el-checkbox__label {
  padding-left: 0;
  color: inherit;
}

.danger-text {
  color: #f56c6c;
  font-size: 12px;
}

.refund-rule-row > .danger-text {
  grid-column: 3;
  grid-row: 1 / span 2;
  align-self: center;
}

.config-form {
  margin-bottom: 20px;
}

.button-group {
  display: flex;
  justify-content: flex-start;
  padding-top: 15px;
  border-top: 1px solid #eef2f7;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
  border: 1px solid #e8e8e8;
}

.loading-content {
  text-align: center;
}

.loading-text {
  margin-top: 10px;
  color: #666;
}

.no-department-tip {
  background-color: #fff;
  border-radius: 4px;
  padding: 60px 20px;
  text-align: center;
  color: #999;
  border: 1px solid #e8e8e8;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-inline {
  padding: 26px 0;
  color: #94a3b8;
  font-size: 13px;
  text-align: center;
}

/* 窄屏响应式优化：防止 200px 大 Label 导致表单内容在分栏或缩小窗口时挤扁 */
@media (max-width: 992px) {
  .dish-config-container {
    padding: 16px;
  }
  .page-title {
    align-items: flex-start;
    flex-direction: column;
  }
  .refund-rule-header,
  .refund-rule-row {
    align-items: flex-start;
    flex-direction: column;
  }
  .refund-rule-row {
    display: flex;
  }
  .rule-time-group {
    flex-basis: auto;
    width: 100%;
  }
  .refund-rule-meals {
    display: flex;
    width: 100%;
    align-items: flex-start;
    flex-direction: column;
    padding: 10px 0 0;
    border-top: 1px solid #e5eaf2;
    border-left: 0;
  }
  .meal-day-group {
    width: 100%;
    box-sizing: border-box;
  }
  .config-card >>> .el-form-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
    margin-bottom: 18px;
  }
  .config-card >>> .el-form-item__label {
    width: 100% !important;
    text-align: left !important;
    padding: 0 0 6px !important;
    line-height: 1.35 !important;
    font-weight: 600;
    color: #334155;
  }
  .config-card >>> .el-form-item__content {
    margin-left: 0 !important;
    width: 100% !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 1180px) and (min-width: 993px) {
  .refund-rule-actions {
    justify-content: flex-start;
  }
  .refund-rule-row {
    grid-template-columns: 28px minmax(0, 1fr) 42px;
  }
  .refund-rule-meals {
    gap: 8px;
  }
  .meal-day-group {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>